<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/sms/index')">mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>مشاهده اطلاعات قالب پیامکی</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-textarea disabled color="black" v-model="sms.content" label="متن قالب پیامکی"></v-textarea>
          </v-col>
          <v-col cols="10">
            <v-autocomplete disabled multiple :items="schools" item-text="label" item-value="id"
                            label="آموزشگاه های  انتخاب شده." v-model="sms.school_ids"></v-autocomplete>
          </v-col>
          <v-col cols="10">
            <v-autocomplete disabled multiple :items="classes" item-text="title" item-value="id"
                            label="کلاس های  انتخاب شده." v-model="sms.class_ids"></v-autocomplete>
          </v-col>
          <v-col cols="2">
            <v-switch v-model="sms.status" label="وضعیت" disabled :true-value="1"
                      :false-value="0"></v-switch>
          </v-col>
          <v-col>
            <v-data-table
                align="center"
                :headers="headers"
                :items="sms.instructors.length ?  sms.instructors : sms.students"
                :items-per-page="10"
                disable-sort
                hide-default-footer>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: "SmsEditView",
  data() {
    return {
      uploadFileDialog: false,
      schools: [],
      classes: [],
      headers: [
        {text: 'نام', value: 'name', align: 'center'},
        {text: 'شماره همراه', value: 'mobile', align: 'center'},
        {text: 'تاریخ ارسال', value: 'created_at_fa', align: 'center'},
      ],
      sms: {
        status: null,
        content: null,
        school_ids: []
      }
    }
  },
  mounted() {
    this.getSms()
    this.getSchools()
  },
  methods: {
    buildQueryString(params) {
      return Object.keys(params)
          .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
          .join('&');
    },
    update() {
      window.axios.post('message/sms/update/' + this.$route.params.id, {
        content: this.sms.content,
        status: this.sms.status,
        school_ids: this.sms.school_ids,
      }).then((res) => {
        this.openSnackbar(res.data.message, 'success')
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getSms() {
      window.axios.get('message/sms/get/' + this.$route.params.id).then((res) => {
        this.sms = res.data.data
        this.getClasses()
      })
    },
    getSchools() {
      window.axios.get('/school/admin-index').then((res) => {
        this.schools = res.data.data
      })
    },
    getClasses() {
      let params = {
        school_ids: this.sms.school_ids.join()
      };
      window.axios.get(`/class/crud/index?${this.buildQueryString(params)}&per_page=1000`).then((res) => {
        this.classes = res.data.data.data
      })
    }
  }
}
</script>

<style scoped>

</style>